import { JSX } from 'react';
import { useRecordContext } from 'react-admin';
import { CompanyDomainsPanel } from '../Company/CompanyDomainsPanel';
import { useCustomerAccountAllowances } from './CustomerAccountAllowanceProvider';

/**
 * The domains of one company on the account's Company and Domain tab.
 *
 * Rendered as the expanded half of a company row, so the record in context is the company rather
 * than the account. The allowance comes from the tab's own read of it, not a second request: the
 * band at the top of the tab and this panel have to agree about how many domains are left, and
 * two separately-timed answers to that question disagree while they settle.
 */
export const CustomerAccountCompanyDomains: () => JSX.Element = (): JSX.Element => {
    const company: any = useRecordContext();
    const { allowances, loadingAllowances, reloadAllowances } = useCustomerAccountAllowances();

    return (
        <CompanyDomainsPanel companyId={ company?.id }
                             customerAccountId={ company?.customerAccount }
                             allowances={ allowances }
                             loadingAllowances={ loadingAllowances }
                             onDomainAdded={ (): void => { reloadAllowances(); } } />
    );
}
